import { render } from "./SpreadSheet.vue?vue&type=template&id=652b0eda&scoped=true&ts=true"
import script from "./SpreadSheet.vue?vue&type=script&lang=ts"
export * from "./SpreadSheet.vue?vue&type=script&lang=ts"

import "./SpreadSheet.vue?vue&type=style&index=0&id=652b0eda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652b0eda"]])

export default __exports__